/**
 * Stable plan key identifiers returned by the dashboard billing API.
 * These match `plan_key` values on the backend — do not change without a
 * coordinated backend update.
 */
export const PLAN_KEYS = {
  enterprise: 'enterprise',
  v2Pro: 'v2_pro',
} as const;
